export const accordionData = [
    {
        title: `What do I need for my first class?`,
        content: `For Gi class you will need to either bring your own Gi or arrange with us to get a loaner one. For submission grappling you will need a t- shirt and shorts with no zips and other metal elements. You should bring some water as well and a pair of flip flops, especially if you want to use the shower.`
    },
    {
        title: `Do I need to have previous experience ?`,
        content: `Everyone has to start somewhere and we are very much aimed at beginners, so don't worry if you never trained any grappling sports. Previous expierence always helps but is not essential.`
    },
    {
        title: `Do I need to improve my fitness before I start training ?`,
        content: `Just like you don't need to wait to be learn more before going to school, you don't need to be more fit to start training.`
    },
    {
        title: `Is BJJ good for self defense?`,
        content: `We focus on sport aspect of Brazilian Jiu Jitsu, but anything you learn can definitely benefit you in any type of self defence scenario.`
    },
    {
        title: `Where can I park nearby?`,
        content: `There is paid parking next to the building (off New England Street) but have some cash just in case as online payment system apparently happens to have occasional issues. There are also bicycle racks in front of the building if you are cycling.`

    },
    {

        title: `Do I need a gumshield?`,
        content: `It's not a requirement, but its definitely very much recommended to have one for any sparring.`


    },
    {
        title: `How can I pay?`,
        content: `We accept cash(try to bring exact amount), card payments on the day or bank transfer.`

    },
    {
        title: `Are there changing facilities?`,
        content: `Unfortunately we don't have access to dedicated changing facility as such, but next door there is a spacious disabled bathroom`
    },
    {
        title: `Are there showers ?`,
        content: `There are showers in both bathrooms on our floor that we can use.`

    },
    {
        title: `I'm a small person. Will I get smashed by bigger training partners?`,
        content: `We aim to create a safe training experience for everyone. We urge people to use their common sense and care for their training partners.`
    },
    {
        title: `Do you offer free sessions?`,
        content: `No we don't. We would like to think our pay as you go prices are affordable enough. See our Prices page for more infomation.`

    },
    {
        title: `I want to train in different clubs and don't want to commit to one. Is that ok?`,
        content: `Absolutely yes. We encourage cross training and we are very much against any tribal nonsense in jiu jitsu.`
    },
    
]